var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ColorStyleBtn, ColorStyleColor, ColorStyleInfoContainer, ColorStyleLinkedInput, ColorStyleSubText, ColorStyleText, SelectColor, } from './styles';
import { faUnlink } from '@fortawesome/pro-regular-svg-icons/faUnlink';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { findThemeName, findThemeValue } from '../../../utils/theme';
export var ThemeInput = function (_a) {
    var themeId = _a.themeId, onClick = _a.onClick, background = _a.background, linked = _a.linked, onUnlink = _a.onUnlink, allThemes = _a.allThemes, _b = _a.field, field = _b === void 0 ? '' : _b, _c = _a.defaultValue, defaultValue = _c === void 0 ? '' : _c;
    var propertyName = '';
    var propertyValue = '';
    if (findThemeValue(themeId, allThemes) === 'transparent') {
        propertyName = background;
    }
    else if (findThemeValue(themeId, allThemes) === undefined) {
        propertyName = defaultValue;
    }
    else {
        if (linked) {
            propertyName = findThemeValue(themeId, allThemes);
        }
        else {
            propertyName = background === null || background === void 0 ? void 0 : background.toUpperCase();
        }
    }
    if (background === undefined) {
        propertyValue = 'transparent';
    }
    else {
        propertyValue = background;
    }
    var unLinkThemeVariable = function (variable) {
        var currentValue = findThemeValue(variable, allThemes);
        onUnlink(currentValue, field);
    };
    return (_jsxs(ColorStyleLinkedInput, __assign({ unlinked: linked }, { children: [_jsxs(ColorStyleInfoContainer, __assign({ onClick: onClick }, { children: [propertyName !== '' && (_jsxs(_Fragment, { children: [_jsx(ColorStyleColor, { color: linked ? findThemeValue(themeId, allThemes) : propertyValue }), linked && (_jsx(ColorStyleText, { children: findThemeName(themeId, allThemes) }))] })), _jsx(ColorStyleSubText, __assign({ mainText: linked }, { children: propertyName === '' ? (_jsx(SelectColor, { children: "Click here to select a color" })) : (propertyName) }))] })), linked && (_jsx(ColorStyleBtn, __assign({ onClick: function () { return unLinkThemeVariable(background); } }, { children: _jsx(FontAwesomeIcon, { size: "sm", icon: faUnlink }) })))] })));
};
export default ThemeInput;
